import sumoLogo from '../images/sumo_logo.png'
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from '../components/dialog'

import { Button } from '../components/button'
import { PlusIcon } from '@heroicons/react/16/solid'

import { Input } from '../components/input'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { useState, useEffect, useRef } from 'react'
import { Badge } from '../components/badge'

import { Loader } from '../components/loader';
import { useNavigate } from 'react-router-dom';
import { Avatar } from '../components/avatar'
import { Heading, Subheading  } from '../components/heading'
import { Checkbox, CheckboxField, CheckboxGroup } from '../components/checkbox'

import { AuthLayout } from '../components/auth-layout'
import config from '../config.js'

import { ErrorNotification, SuccessNotification } from '../components/notification';
import { useAlert } from "../components/customAlert";
import { object } from 'framer-motion/client'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ListCompanies() {
	const { showAlert } = useAlert();
	const navigate = useNavigate();
	//const [accounts, setAccounts] = useState([]); 
	const [products, setProducts] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [selectedAccounts, setSelectedAccounts] = useState([]);
	const [page, setPage] = useState(1);	
	const limit = 10;
	const [total, setTotal] = useState(0);
	const [popupMessage, setPopupMessage] = useState('');
	const [popupHeading, setPopupHeading] = useState('');
	const [loading, setLoading] = useState(false);
	const [confirmed, setConfirmed] = useState(false);//for confirmation
	let [isOpen, setIsOpen] = useState(false);
	let [isOpenConfirm, setIsOpenConfirm] = useState(false);
	const [selectedCompName, setSelectedCompName] = useState('');
	const [selectedCompCntry, setSelectedCompCntry] = useState('');
	const [selectedCompPrdt, setSelectedCompPrdt] = useState('');
	const [selectedCompMail, setSelectedCompMail] = useState('');
	const [errorMsg, setErrorMsg] = useState('');
  	const [showErrorBox, setShowErrorBox] = useState(false);

	const [gmcEmail, setMail] = useState('');
	const [serverError, setServerError] = useState('');
	
	// Fetch paginated product data
	const fetchProducts = async (pageNum) => {
		setLoading(true); // show loader
		try {
			//const res = await fetch(`${config.apiPath}/gmc-setup/gmc-account-fetch.php?gmc_mail_id=${encodeURIComponent(gmcEmail)}`,{ credentials: 'include' });
			//const res = await fetch(`${config.apiPath}/gmc-setup/gmc-account-fetch.php?gmc_mail_id=feedsumodemo@gmail.com`,{ credentials: 'include' });
			
			//&gmc_mail_id=${encodeURIComponent(gmcEmail)}
			//insert token data in SUMO_ALL_GMC_ACCOUNTS & enable user
			const res = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=addAccount`,{ credentials: 'include' });
			const data = await res.json();
			//console.log(data);
			//if email session is not found, then it will call else part
			if(data.status==='success' && data.mail){
				//set mail address
				setMail(data.mail);
				
				//check if already exists with linked_accounts in SUMO_ALL_GMC_ACCOUNTS then response = success, if not exists (no linked_accounts) then response = error
				const check_exists = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=check_acc_exists&gmc_mail_id=${encodeURIComponent(data.mail)}`,{ credentials: 'include' });
				const check_exists_data = await check_exists.json();
				
				//only call if account already not found - to avoid multiple fetch
				var res1 = data1 = '';
				if(check_exists_data.status==='error'){				
				  //all accounts insert cron call with specific email				
				  var res1 = await fetch(`${config.apiPath}/gmc-setup/gmc-account-fetch-cron.php?process=add_account&gmc_mail_id=${encodeURIComponent(data.mail)}`,{ credentials: 'include' });
				  var data1 = await res1.json();
				}
				
				if(data1.status==='success' || check_exists_data.status==='success'){					
					//collect accounts for specific email address
					const res2 = await fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=get_acc_list_full&gmc_mail_id=${encodeURIComponent(data.mail)}`,{ credentials: 'include' });
					const data2 = await res2.json();
					
					setProducts(data2.products);					
					setTotal(data2.total);
				}else{					
					setLoading(false); // hide loader
					showAlert(data1.msg, "Error" , "error",3000);

					setTimeout(() => {
						navigate('/account-setup');	
					});				
				}
			}else{				
				setLoading(false); // hide loader
				showAlert(data.msg, "Error" , "error",3000);//session expired msg
				
				setTimeout(() => {
					navigate('/account-setup');	
				});			
			}					
			
		} catch(error) {
			console.error("Fetch error", error);
		} finally {
			setLoading(false); // hide loader
		}
	};
	
	//to avoid duplicate requests
	const didFetch = useRef(false);
	useEffect(() => {
	  if (!didFetch.current) {
		didFetch.current = true;
		fetchProducts(page);
	  }
	}, [page]);
	
	useEffect(() => {
  	if (confirmed) {
		  setConfirmed(false); // reset flag
		  
		  //setPopupHeading('✅ Success');
		  //setPopupMessage("Add company process initiated, once completed, you will get mail");		  
		  //setIsOpen(true);		
		  console.log("added companies:", selectedIds);
		  console.log("mail:", gmcEmail);
		 
		  
		  
		  // Trigger async without await
		  setTimeout(() => {
			fetch(`${config.apiPath}/gmc-setup/gmc-handler.php?process=add_company&user_email=${gmcEmail}&mail=${gmcEmail}&ids=${selectedIds}`,
			{ credentials: 'include' });
		  }, 0);
		  
		  setSelectedIds([]);
		  //fetchProducts(page);
		  
		  /*setTimeout(() => {*/
		  	navigate('/data-import-progress',{ state: { gmcEmail: gmcEmail,selectedIds: selectedIds } });
		  /*}, 100);*/
		}
	}, [confirmed, page, selectedIds]);
	
	// Handle checkbox toggle
	const handleCheckboxChange = (id) => {
		if (!id) return; // prevent pushing undefined
		
		setSelectedIds((prev) => {
		  const newSelected = prev.includes(id)
			? prev.filter((item) => item !== id) // unselect
			: [...prev, id]; // select
	  
		  // get account objects from products
		  const accounts = products.filter((p) => newSelected.includes(p.dataSourceId));
		  setSelectedAccounts(accounts);
	  
		  return newSelected;
		});		
	};
	
	const handleAddCompany = async () => {
		console.log("added companies:", selectedIds);
		if (selectedIds.length === 0) {
			//setPopupHeading('⚠️ Alert');
			//setPopupMessage('Please select at least one account to proceed.');
			//setIsOpen(true);
			showAlert('Please select atleast one feed to proceed.', "Error" , "error",3000);

			return;    	  	
		}
		// Show confirmation popup
		setIsOpenConfirm(true);   	
	};
	
	const handleCancel = () => {
		setSelectedIds([]);
	};
	
	return (
<AuthLayout>
	<ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	<div className="flex w-full grid grid-cols-1 gap-x-8 gap-y-2 !align-center !content-center">

		<div className="flex justify-center"><Avatar square className="!size-20" src={sumoLogo} /></div>
		<Heading className="text-center !text-4xl py-2">Welcome to FeedSumo</Heading>
		<Heading className="text-center !text-1xl ">Let's get you started</Heading>
		<Heading className="text-center !text-1xl ">OK! We have found the following accounts, select all those we should include</Heading>
		{loading ? (<Loader />) : (
			<>
			{total > 0 ?(
		<div>
			<ul role="list" className="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-1 lg:grid-cols-1">

			{products.map((acc) => (
				<li	key={acc.account_id} className="col-span-1 flex rounded-md shadow-md dark:shadow-none bg-stone-600 dark:bg-gray-900">
				
				{/* first heading block aggregator/merchant id, title */}
				<div className="w-1/5  text-white rounded-l-md m-auto">
					<div className="text-center rounded-l-md text-sm/6 font-medium m-4">
					<p>{acc.account_name}</p>
					<p>({acc.account_id})</p>
					</div>
				</div>
				
				{/* Case 1: aggregator -> merchant */}
				{acc.aggregator_id && acc.aggregator_id !== '' ? (
					<div className="flex flex-1 items-center justify-between truncate bg-white dark:bg-gray-800/50">
						<div className="flex-1 truncate text-sm/6 max-h-[300px] overflow-y-auto">
							<ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-2 lg:grid-cols-1">
							{/*{acc.merchants.map((merchant) => (*/}
								{Object.values(acc.merchants).map((merchant)=>(
								<li key={merchant.merchant_id} className="col-span-1 flex dark:shadow-none bg-stone-200 dark:bg-gray-900">
									
									{/*merchant details start*/}
									<div class="w-1/4 m-auto">
										<div className={classNames("",'flex items-center justify-center  whitespace-break-spaces rounded-l-md text-sm/6 font-medium m-4',)} >
                            			{merchant.merchant_name} ({merchant.merchant_id})
                          				</div>
									</div>
									{/*merchant details ends*/}

									{/*feeds start*/}
									<div className="flex flex-1 items-center justify-between truncate  bg-white dark:bg-gray-800/50">
									<div className="flex-1 truncate text-sm/6">
									<ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
										<li className="col-span-1 flex dark:shadow-none bg-gray-200 dark:bg-gray-900">
											<div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
											<div className="text-sm/6 w-full">
											<ul role="list" className="grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1">
												{Object.values(merchant.feeds || {}).map((feed) => {
													const feedCount = Object.values(merchant.feeds || {}).length;
													return (<li key={feed.dataSourceId} className={`col-span-1 flex rounded-md ${feedCount > 1 ? "shadow-xs":""} dark:shadow-none`}>
														<div className="flex flex-1 items-center justify-between truncate  rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
															<div className="flex truncate px-4 py-2 text-sm/6 w-full">
																<div className='w-1/5'>
																<div class="text-gray-500 text-sm font-semibold">Feed ID</div>
																<div class="text-sm text-gray-900 dark:text-gray-100">{feed.dataSourceId}</div>
																</div>
																<div className='w-2/5'>
																<div class="text-gray-500 text-sm font-semibold">Feed Name</div>
																<div class="text-sm text-gray-900 whitespace-break-spaces break-normal dark:text-gray-100">{feed.feed_display_name}</div>
																</div>
																<div  className='w-1/5'>
																<div class="text-gray-500 text-sm font-semibold">Country</div>
																<div class="text-sm text-gray-900 dark:text-gray-100">{feed.country}</div>
																</div>																
																<div className='w-1/5 m-auto'>
																<span className="ml-6 flex h-7 items-center float-right">
																	<CheckboxGroup>
																	<CheckboxField>
																		<Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes(feed.dataSourceId)} onChange={() => handleCheckboxChange(feed.dataSourceId)} />
																	</CheckboxField>
																	</CheckboxGroup>
																</span>
																</div>
															</div>
														</div>
													</li>);
												})}
											</ul>
											</div>
											</div>
										</li>
									</ul>
									</div>
									</div>
									{/*feeds ends*/}
								</li>						
							))}
							</ul>
						</div>
					</div>
				) : (
				// Case 2: direct merchant (no aggregator)
				<div className="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-gray-200 bg-white dark:border-white/10 dark:bg-gray-800/50 w-full">
					<ul role="list" class="max-h-[300px] overflow-y-auto grid grid-cols-1 gap-2 sm:grid-cols-1 sm:gap-2 lg:grid-cols-1 w-full">
					{Object.values(acc.merchants || {}).map((merchant) => {					
						const feedCount = Object.values(merchant.feeds || {}).length;
					return Object.values(merchant.feeds || {}).map((feed) => {	
						return (<li key={feed.dataSourceId} class={`col-span-1 flex rounded-md ${feedCount > 1 ? "shadow-xs" : ""} dark:shadow-none`}>				
						<div className="flex truncate px-4 py-2 text-sm/6 w-full">
							<div className='w-1/5'>
								<div class="text-gray-500 text-sm font-semibold">Feed ID</div>
								<div class="text-sm text-gray-900 dark:text-gray-100">{feed.dataSourceId}</div>
							</div>
							<div className='w-2/5'>
								<div class="text-gray-500 text-sm font-semibold">Feed Name</div>
								<div class="text-sm text-gray-900 whitespace-break-spaces break-normal dark:text-gray-100">{feed.feed_display_name}</div>
							</div>
							<div  className='w-1/5'>
								<div class="text-gray-500 text-sm font-semibold">Country</div>
								<div class="text-sm text-gray-900 dark:text-gray-100">{feed.country}</div>
							</div>							
							<div className='w-1/5 m-auto'>
								<span className="ml-6 flex h-7 items-center float-right">
									<CheckboxGroup>
									<CheckboxField>
										<Checkbox name="discoverability" value="show_on_events_page" checked={selectedIds.includes(feed.dataSourceId)} onChange={() => handleCheckboxChange(feed.dataSourceId)} />
									</CheckboxField>
									</CheckboxGroup>
								</span>
							</div>
						</div>	
						</li>);				
					})
				})}
				</ul>
				</div>
				)}

				</li>
			))}
			</ul>
		</div>	
		):(
			<Subheading className="text-center py-2">No records found.</Subheading>
		) }
		</>
		)}
		

		
				
		{/* Action Buttons starts*/}
		{total > 0 && (
			<>
			<Subheading className="text-center py-2">No changes will be made to your accounts, we will just sync the data over and analyse it.</Subheading>
			<div className="mt-2 flex space-x-4 justify-center">				
				<Button class="w-40 cursor-pointer" onClick={handleAddCompany}><PlusIcon />Add Company</Button>
				<Button color="white" class="w-40 cursor-pointer" onClick={handleCancel}>Clear</Button>
			</div>
			</>
		)}
		{/* Action Buttons ends*/}

		{/*dialog start*/}
		<Dialog open={isOpen} onClose={setIsOpen}>
			<DialogTitle>{popupHeading}</DialogTitle>
			<DialogDescription>{popupMessage}</DialogDescription>
			<DialogBody></DialogBody>
			<DialogActions>
				<Button onClick={() => setIsOpen(false)}>Close</Button>
			</DialogActions>
		</Dialog>
		{/*dialog end*/}
		
		{/*confirm dialog start*/}
		<Dialog open={isOpenConfirm} onClose={setIsOpenConfirm} size="xl">
			<DialogTitle>Confirm</DialogTitle>
			<DialogDescription>Are you sure, you want to add the below selected feeds?</DialogDescription>
			<DialogBody className="text-sm/6 text-zinc-900 dark:text-white">
				<Table>
					<TableHead>
						<TableRow className="text-zinc-950 dark:text-white">
							<TableHeader>Feed ID</TableHeader>
							<TableHeader>Feed Name</TableHeader>
							<TableHeader>Country</TableHeader>
						</TableRow>
					</TableHead>
					<TableBody>
						{/*selectedAccounts.map((acc) => (
				  			<TableRow key={acc.dataSourceId}>
								<TableCell className="text-zinc-500">{acc.account_name}</TableCell>
								<TableCell className="text-zinc-500">{acc.country}</TableCell>
								<TableCell className="text-zinc-500">{acc.productCount}</TableCell>					
				  			</TableRow>
						))*/}

						{/*acc.merchants.map(merchant =>*/}
						{products.map(acc =>
							Object.values(acc.merchants).map(merchant => 
							Object.values(merchant.feeds || {}).map(feed =>
								selectedIds.includes(feed.dataSourceId) && (
								<TableRow key={feed.dataSourceId}>
									<TableCell className="text-zinc-500">{feed.dataSourceId}</TableCell>
									<TableCell className="text-zinc-500">{feed.feed_display_name}</TableCell>
									<TableCell className="text-zinc-500">{feed.country}</TableCell>
									
								</TableRow>
								)
							)
							)						
						)}

					</TableBody>
				</Table>
			</DialogBody>
			<DialogActions>
				<Button plain onClick={() => setIsOpenConfirm(false)}>Cancel</Button>
				<Button onClick={() => {setIsOpenConfirm(false);setConfirmed(true);}}>Yes Proceed</Button>
			</DialogActions>
		</Dialog>
		{/*confirm dialog end*/} 
	</div>
</AuthLayout>
);
}